import { useContext, useEffect } from 'react';
import axios from 'axios';
import { MapContext } from '../../context/MapContext';
import { AppContext } from '../../context/AppContext';
import { unByKey } from 'ol/Observable';
import { inflowLayers, inoutflowLayers, outflowLayers } from '../map/layers';
import SelectOption from '../option/SelectOption';
import Popup from '../popup/Popup';
import InflowMap from '../map/InflowMap';
import OutflowMap from '../map/OutflowMap';
import InoutflowMap from '../map/InoutflowMap';

let inKey = null;
let outKey = null;
let inOutKey = null;

export default function PartitionWrapper() {
	const { mapMode, execFunctionLog } = useContext(AppContext);
	const {
		inPopupOpen,
		setInPopupOpen,
		outPopupOpen,
		setOutPopupOpen,
		inOutPopupOpen,
		setInOutPopupOpen,
		inPopupData,
		setInPopupData,
		inPopupPosition,
		setInPopupPosition,
		outPopupData,
		setOutPopupData,
		outPopupPosition,
		setOutPopupPosition,
		inOutPopupData,
		setInOutPopupData,
		inOutPopupPosition,
		setInOutPopupPosition,
		zoomLevel,
		setZoomLevel,
		inflowMapRef,
		outflowMapRef,
		inoutflowMapRef,
	} = useContext(MapContext);

	useEffect(() => {
		if (mapMode === 'in') {
			inflowMapRef.current.updateSize();
		} else if (mapMode === 'out') {
			outflowMapRef.current.updateSize();
		} else if (mapMode === 'inout') {
			inoutflowMapRef.current.updateSize();
		} else {
			inflowMapRef.current.updateSize();
			outflowMapRef.current.updateSize();
		}
	}, [mapMode]);

	let key = null;
	useEffect(() => {
		// mapMode에 따라 적절한 맵에서 줌 레벨 감지
		let currentMapRef = null;

		if (mapMode === 'in') {
			currentMapRef = inflowMapRef.current;
		} else if (mapMode === 'out') {
			currentMapRef = outflowMapRef.current;
		} else if (mapMode === 'inout') {
			currentMapRef = inoutflowMapRef.current;
		} else {
			currentMapRef = inflowMapRef.current;
		}

		if (currentMapRef) {
			if (key) {
				unByKey(key);
				key = null;
			} else {
				key = currentMapRef.on('moveend', function (e) {
					const newZoom = parseInt(currentMapRef.getView().getZoom());
					if (zoomLevel !== newZoom) {
						setZoomLevel(newZoom);
					}
				});
			}
		}
		if (zoomLevel >= 9) {
			if (mapMode === 'in') {
				inflowMapRef.current.updateSize();
			} else if (mapMode === 'out') {
				outflowMapRef.current.updateSize();
			} else if (mapMode === 'inout') {
				inoutflowMapRef.current.updateSize();
			} else {
				inflowMapRef.current.updateSize();
				outflowMapRef.current.updateSize();
			}
		}
	}, [zoomLevel, mapMode, inflowMapRef, outflowMapRef, inoutflowMapRef]);

	const inKeyCallBack = function (e) {
		execFunctionLog(
			'유입 중심성 지수별 거점 분석',
			'유입 중심 거점 격자 정보 조회 기능 제공'
		);
		const viewResolution = inflowMapRef.current.getView().getResolution();
		const url = inflowLayers.centralHubT
			.getSource()
			.getFeatureInfoUrl(e.coordinate, viewResolution, 'EPSG:3857', {
				INFO_FORMAT: 'application/json',
			});
		if (url) {
			axios({
				method: 'GET',
				url,
				withCredentials: true,
			}).then((res) => {
				if (res.status === 200) {
					const { data } = res;
					if (data.features.length > 0) {
						setInPopupPosition({
							x: e.originalEvent.clientX,
							y: e.originalEvent.clientY,
						});

						const properties = data.features[0].properties;
						// console.log(properties);
						const pc_grid_nm = properties.pc_grid_nm;
						const pc_pop_w = properties.pc_pop_w;
						const pc_pop_r = properties.pc_pop_r;
						const pc_in_val = properties.pc_in_val;
						const pc_out_val = properties.pc_out_val;
						setInPopupData({
							pc_grid_nm,
							pc_pop_w,
							pc_pop_r,
							pc_in_val,
							pc_out_val,
						});
						setInPopupOpen(true);
					} else {
						setInPopupOpen(false);
						setInPopupPosition({ x: 0, y: 0 });
						setInPopupData({
							pc_grid_nm: '',
							pc_pop_w: 0,
							pc_pop_r: 0,
							pc_in_val: 0,
							pc_out_val: 0,
						});
					}
				}
			});
		}
	};
	const outKeyCallBack = function (e) {
		execFunctionLog(
			'유출 중심성 지수별 거점 분석',
			'유출 중심 거점 격자 정보 조회 기능 제공'
		);
		setOutPopupPosition({
			x: e.originalEvent.clientX,
			y: e.originalEvent.clientY,
		});

		const viewResolution = outflowMapRef.current.getView().getResolution();
		const url = outflowLayers.centralHubT
			.getSource()
			.getFeatureInfoUrl(e.coordinate, viewResolution, 'EPSG:3857', {
				INFO_FORMAT: 'application/json',
			});
		if (url) {
			axios({
				method: 'GET',
				url,
				withCredentials: true,
			}).then((res) => {
				if (res.status === 200) {
					const { data } = res;
					if (data.features.length > 0) {
						const properties = data.features[0].properties;
						// console.log(properties);
						const pc_grid_nm = properties.pc_grid_nm;
						const pc_pop_w = properties.pc_pop_w;
						const pc_pop_r = properties.pc_pop_r;
						const pc_in_val = properties.pc_in_val;
						const pc_out_val = properties.pc_out_val;
						setOutPopupData({
							pc_grid_nm,
							pc_pop_w,
							pc_pop_r,
							pc_in_val,
							pc_out_val,
						});
						setOutPopupOpen(true);
					} else {
						setOutPopupOpen(false);
						setOutPopupPosition({ x: 0, y: 0 });
						setOutPopupData({
							pc_grid_nm: '',
							pc_pop_w: 0,
							pc_pop_r: 0,
							pc_in_val: 0,
							pc_out_val: 0,
						});
					}
				}
			});
		}
	};
	const inOutKeyCallBack = function (e) {
		execFunctionLog(
			'유입⋅유출 중심성 지수별 거점 분석',
			'유입⋅유출 거점 격자 정보 조회 기능 제공'
		);
		setInOutPopupPosition({
			x: e.originalEvent.clientX,
			y: e.originalEvent.clientY,
		});

		const viewResolution = inoutflowMapRef.current.getView().getResolution();
		const url = inoutflowLayers.centralHubT
			.getSource()
			.getFeatureInfoUrl(e.coordinate, viewResolution, 'EPSG:3857', {
				INFO_FORMAT: 'application/json',
			});
		if (url) {
			axios({
				method: 'GET',
				url,
				withCredentials: true,
			}).then((res) => {
				if (res.status === 200) {
					const { data } = res;
					if (data.features.length > 0) {
						const properties = data.features[0].properties;
						// console.log(properties);
						const pc_grid_nm = properties.pc_grid_nm;
						const pc_pop_w = properties.pc_pop_w;
						const pc_pop_r = properties.pc_pop_r;
						const pc_in_val = properties.pc_in_val;
						const pc_out_val = properties.pc_out_val;
						setInOutPopupData({
							pc_grid_nm,
							pc_pop_w,
							pc_pop_r,
							pc_in_val,
							pc_out_val,
						});

						setInOutPopupOpen(true);
					} else {
						setInOutPopupOpen(false);
						setInOutPopupPosition({ x: 0, y: 0 });
						setInOutPopupData({
							pc_grid_nm: '',
							pc_pop_w: 0,
							pc_pop_r: 0,
							pc_in_val: 0,
							pc_out_val: 0,
						});
					}
				}
			});
		}
	};

	useEffect(() => {
		console.log('inKey: ', inKey);
		console.log('inOutKey: ', inOutKey);
		console.log('zoomLevel: ', zoomLevel);
		if (zoomLevel >= 9 && !inKey) {
			console.log('이벤트 부여됨');

			inKey = inflowMapRef.current.on('singleclick', inKeyCallBack);

			outKey = outflowMapRef.current.on('singleclick', outKeyCallBack);

			inOutKey = inoutflowMapRef.current.on('singleclick', inOutKeyCallBack);
		} else if (zoomLevel < 9 && inKey) {
			console.log('이벤트 제거됨');
			unByKey(inKey);
			unByKey(outKey);
			unByKey(inOutKey);

			inKey = null;
			outKey = null;
			inOutKey = null;
		}
	}, [zoomLevel, inKey]);

	return (
		<div className="partitionWrap">
			{/* 팝업창 */}
			<Popup
				popupOpen={inPopupOpen}
				setPopupOpen={setInPopupOpen}
				popupData={inPopupData}
				popupPosition={inPopupPosition}
			/>
			<Popup
				popupOpen={outPopupOpen}
				setPopupOpen={setOutPopupOpen}
				popupData={outPopupData}
				popupPosition={outPopupPosition}
			/>
			<Popup
				popupOpen={inOutPopupOpen}
				setPopupOpen={setInOutPopupOpen}
				popupData={inOutPopupData}
				popupPosition={inOutPopupPosition}
			/>
			<SelectOption />
			{/* 첫번째 좌측화면 */}
			<OutflowMap />
			{mapMode === 'dual' ? <div className="partitionLine" /> : null}
			{/* 첫번째 우측화면 */}
			<InflowMap />
			{/* 두번째 화면 */}
			<InoutflowMap />
		</div>
	);
}
